<template>
    <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
        <div>
            <el-table :data="commentList"
                      style="width: 100%; margin: 20px"
                      size="mini"
                      border>
                <el-table-column label="姓名" prop="createUserName"></el-table-column>
                <el-table-column label="时间" prop="createTime"></el-table-column>
                <el-table-column label="操作" prop="statusDisplayName"></el-table-column>
                <el-table-column label="内容" prop="comment"></el-table-column>
            </el-table>
            <div style="margin-top: 20px" v-if="commentList.length>0 && commentList[0].status != 2||commentList.length==0">
                <div style="margin-bottom: 10px">回复内容</div>
                <el-row>
                    <el-col :span="16">
                        <el-input
                                type="textarea"
                                placeholder="请输入内容"
                                v-model="commentTxt"
                                maxlength="50"
                                show-word-limit
                                rows="4"
                        >
                        </el-input>
                    </el-col>
                </el-row>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">关 闭</el-button>
            <el-button type="primary" v-if="commentList.length>0 && commentList[0].status != 2 ||commentList.length==0" @click="creatorBtn">回 复</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import {
        getProcessCommentListService,
        processCreatorService,
    } from "@/services/documentServices";
    export default {
        name: "replyComp",
        data(){
            return {
                dialogVisible: false,
                systemFileInternalId: '',
                userId: '',
                commentList: [],
                pageIndex: 1,
                pageSize: 1000,
                commentTxt: ''
            }
        },
        props: {
          userName:{
            type: String,
          },
          checkId:{
            type: Number,
          }
        },
        methods: {
            init(){
                this.commentList = [];
                this.dialogVisible = true;
                this.$nextTick(()=> {
                    this.getProcessCommentList();
                })
            },
            //获取回复列表
            getProcessCommentList(){
                let paramsData = {
                    systemFileInternalId: this.systemFileInternalId,
                    userId: this.userId,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                }
                getProcessCommentListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.commentList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            creatorBtn() {
                if(this.commentTxt == ''){
                  this.$message.error("请填写回复信息！");
                  return
                }
                const loading = this.$loading({
                  lock: true,
                  text: 'Loading',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });
                let params = {
                    comment: `回复${this.userName}：` + this.commentTxt,
                    systemFileInternalCheckId: this.checkId,
                }
                processCreatorService(params).then( res => {
                    if(res.code == 10000000){
                        this.$message.success('回复成功！');
                        this.$emit('refreshDataList');
                        this.commentTxt = '';
                        this.dialogVisible = false;
                    }else{
                        this.$message.error(res.msg);
                    }
                    loading.close();
                }).catch(error => {
                    this.$message.error("网络请求失败");
                    loading.close();
                });
            },
            handleClose(done) {
                done();
            },
        }
    }
</script>

<style scoped lang="scss">
    /deep/.el-dialog {
        width: 50% !important;
        .el-table {
            margin: 0 !important;
        }
    }
</style>
